export default __webpack_public_path__ + "static/media/cancellation.5372e4a7.jpg";